@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 16px;
  background-color: var(--background-soft);
  border: 1px solid var(--border-soft);
  @include border-radius-r2;
  width: 100%;
  height: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
}

.sectionTitle {
  margin-bottom: -8px;
}

.subtitle {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.skeletonWrapper {
  height: 100%;
  width: 100%;
}

.legacyRoot {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.legacyTitleWrapper {
  display: flex;
  flex-direction: column;
}

.legacySectionTitle {
  :global(p) {
    @include typography-v2-title-md;
    text-underline-offset: 8px;
  }

  :global(a > div) {
    margin-bottom: 4px;
  }
}

.legacySubtitleLabel {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
